// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"data-display"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M4 5H4.5C5.05228 5 5.5 5.44772 5.5 6L5.5 15M5.5 15H4M5.5 15H7M10 5H13C13.5523 5 14 5.44772 14 6V9C14 9.55228 13.5523 10 13 10H11C10.4477 10 10 10.4477 10 11V15H14M17 15H20C20.5523 15 21 14.5523 21 14V10M17 5H20C20.5523 5 21 5.44772 21 6V10M21 10H17.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M21 19H4","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const DataDisplayIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'data-display',
    ref,
    icon: element,
  },
));

DataDisplayIcon.displayName = 'DataDisplayIcon';

export default DataDisplayIcon;
